import { nanoid } from 'nanoid/async'

import { fileModal } from './fileModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: fileData } = await fileModal(oldData, node)
  
  if (fileData && Object.values(fileData).length >= 1) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, fileData)
    node.update()
    updateNodeConnections(node)
  }


  return false
}